import "../stylesheets/App.css";
import "../stylesheets/Awards.css";
import React from "react";
import StageItem from "./subcomponents/StageItem.js";
import Header from "./subcomponents/Header.js";

function Awards() {
  const stage = {
    idStage: 7,
    name: "Premios",
    background_url: "images/stage_banners/bg_mispuntos.png",
    active: 1,
  };

  const awards = [
    { src: "dieciseisavos-ganador.png", alt: "Ganador dieciseisavos" },
    { src: "fase-clasificacion-ganador.png", alt: "Ganador fase de clasificación" },
    { src: "octavos-ganador.png", alt: "Ganador octavos" },
    { src: "cuartos-ganador.png", alt: "Ganador cuartos" },
    { src: "tercer-ganador.png", alt: "Tercer ganador" },
    { src: "segundo-ganador.png", alt: "Segundo ganador" },
    { src: "primer-ganador.png", alt: "Primer ganador" },
  ];

  return (
    <>
      <Header />
      <section className="stage-page ranking-page awards-page">
        <StageItem stage={stage} />
      </section>
      <section className="awards-list">
        {awards.map((award) => (
          <img
            key={award.src}
            className="awards-img"
            src={process.env.PUBLIC_URL + "/images/awards/" + award.src}
            alt={award.alt}
          />
        ))}
      </section>
    </>
  );
}

export default Awards;